import type {
  ShopClickedAttributes,
  ShopImpressionsLoadedAttributes,
  ShopListExpandedAttributes,
  ShopListLoadedAttributes,
  ShopListUpdatedAttributes,
} from '@glovo/perseus-events-perseus'
import {
  PageType,
  ShopClicked,
  ShopImpressionsLoaded,
  ShopListExpanded,
  ShopListLoaded,
  ShopListUpdated,
} from '@glovo/perseus-events-perseus'

export const ShopImpressionsLoadedEvent = (attributes: ShopImpressionsLoadedAttributes) =>
  new ShopImpressionsLoaded({ ...attributes, pageType: PageType.ShopList })

export const ShopListExpandedEvent = (attributes: ShopListExpandedAttributes) =>
  new ShopListExpanded({ ...attributes, pageType: PageType.ShopList })

export const ShopListLoadedEvent = (attributes: ShopListLoadedAttributes) =>
  new ShopListLoaded({ ...attributes, pageType: PageType.ShopList })

export const ShopListUpdatedEvent = (attributes: ShopListUpdatedAttributes) =>
  new ShopListUpdated({ ...attributes, pageType: PageType.ShopList })

export const ShopClickedEvent = (attributes: ShopClickedAttributes) =>
  new ShopClicked({ ...attributes, pageType: PageType.ShopList })
